import { z } from 'zod';
import { pageFields, pageQuery, timestampSchema } from './common';

export const QUEUE_SOURCES = ['jobs', 'integration_events', 'subscription_effects'] as const;
export type QueueSource = (typeof QUEUE_SOURCES)[number];

export const QUEUE_LABELS: Record<string, string> = {
  'classify-question': 'Niveaucontrole',
  'classify-question-failed': 'Uitgevallen niveaucontrole',
  'sweep-classifications': 'Controle op wachtende niveaucontroles',
  'process-integration-event': 'Bestelling of betaling verwerken',
  'run-subscription-effects': 'Abonnementsacties uitvoeren',
  'billing-sweep': 'Controle op wachtende betaalberichten',
  'nightly-billing-check': 'Nachtelijke abonnementscontrole',
  'shop-sync': 'Webshop controleren',
  'make-question-image': 'Vraagafbeelding maken',
  'sweep-question-images': 'Controle op wachtende afbeeldingen',
};

export const queueStateSchema = z.enum([
  'waiting',
  'scheduled',
  'retry',
  'active',
  'completed',
  'cancelled',
  'failed',
  'awaiting_payment',
]);
export const queueListQuerySchema = z.object({
  view: z.enum(['open', 'history']).default('open'),
  queue: z.string().trim().min(1).max(100).optional(),
  state: queueStateSchema.optional(),
  search: z.string().trim().max(200).optional(),
  ...pageQuery,
});
export const queueJobQuerySchema = z.object({ queue: z.string().min(1).max(100) });

export const queueItemSchema = z.object({
  id: z.uuid(),
  kind: z.enum(['job', 'event', 'effect']),
  queue: z.string(),
  state: queueStateSchema,
  summary: z.string(),
  reference: z.string(),
  userId: z.uuid().nullable(),
  questionId: z.uuid().nullable(),
  recordStatus: z.string().nullable(),
  createdAt: timestampSchema,
  startedAt: timestampSchema.nullable(),
  completedAt: timestampSchema.nullable(),
  availableAt: timestampSchema.nullable(),
  attempts: z.int().min(0),
  retryLimit: z.int().min(0).nullable(),
  retryDelaySeconds: z.int().min(0).nullable(),
  retryBackoff: z.boolean().nullable(),
  expireSeconds: z.int().min(0).nullable(),
  sourceJobId: z.uuid().nullable(),
  error: z.string().nullable(),
});
export const queueListSchema = z.object({ items: z.array(queueItemSchema), ...pageFields });
export const queueOverviewSchema = z.object({
  capturedAt: timestampSchema,
  queues: z.array(z.string()),
  counts: z.array(z.object({ state: queueStateSchema, count: z.int().min(0) })),
});

export type QueueState = z.infer<typeof queueStateSchema>;
export type QueueItem = z.infer<typeof queueItemSchema>;
export type QueueListQuery = Partial<QueueListFilters>;
export type QueueListFilters = z.output<typeof queueListQuerySchema>;
export type QueueList = z.infer<typeof queueListSchema>;
export type QueueOverview = z.infer<typeof queueOverviewSchema>;
